// src/modules/clinical-note-ai/constants/analysisSchema.js

export const DEFAULT_ANALYSIS = {
  summary: '',
  keyFindings: [],
  possibleDiagnoses: [], // [{ name, rationale }]
  recommendedTests: [],
  treatmentOptions: [], // [{ name, why, risks }]
  redFlags: [],
  missingInfo: [],
  confidence: 0.0, // 0..1
  hipaaNote: 'No patient identifiers included in output.',
};
